import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";

// OBTENER TODAS LoS Tipos
export const getObtenerTypes = async () => {
  const respuesta = await PrivateInterceptor(`Base/Global/Types`, "GET");
  return respuesta;
};


// OBTENER TODAS LoS Tipos
export const getTypesCat = async () => {
  const respuesta = await PrivateInterceptor(`Base/Global/Types/TypesCat`, "GET");
  return respuesta;
};


// OBTENER TODAS LoS Tipos
export const getTypesCategoria = async (TypeCategoria) => {
  const respuesta = await PrivateInterceptor(`Base/Global/Types/TypesCategoria/${TypeCategoria}`, "GET");
  return respuesta;
};

//OBTENER TIPOS PURCHASETERMS
export const getTypesPurchaseTerms = async () => {
  const respuesta = await PrivateInterceptor(`Base/Global/Types/PurchaseTerms`, "GET");
  return respuesta;
};

// AGREGAR Tipos
export const addTypes = async (data) => {
  const respuesta = await PrivateInterceptor(
    `Base/Global/Types/add`,
    "POST",
    data
  );
  return respuesta;
};


